import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";

const initState = {
    bankInformation: "",
    amountCollected: null,
    amountCollectedDate: null
};

export const PaymentApprovalData = {
    name: "Record list form",
    initialState: initState,
    section: [
        {
            title: "Record list form",
            row: {},
            style: {
                sectionStyle: "row verticle-form",
            },
            rowGroup: [
                {
                    groupLabel: "Task List form", // Group for contact fields
                    style: {
                        groupStyle: "col-lg-12 col-md-12 mb-2",
                    },
                    groupWrapper: <div className="form-card row"></div>, // Wrapper HTML or Component
                    fields: [
                        {
                            id: "bankInformation",
                            label: "Bank Information",
                            Field_Name: "Bank Information",
                            fieldType: FormFieldTypes.SELECT,
                            dataField: "bankInformation",
                            fieldSetting: {
                                placeholder: "Select",
                                options: [],
                                isMultiSelect: false
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
                            },
                        },
                        {
                            id: "amountCollected",
                            label: "Amount Collected",
                            Field_Name: "Amount Collected",
                            fieldType: FormFieldTypes.NUMERIC,
                            dataField: "amountCollected",
                            fieldSetting: {
                                placeholder: "Amount Collected",
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
                            },
                        },
                        {
                            id: "amountCollectedDate",
                            label: "Amount Collected Date",
                            Field_Name: "Amount Collected Date",
                            fieldType: FormFieldTypes.DATEPICKER,
                            dataField: "amountCollectedDate",
                            fieldSetting: {
                                placeholder: "dd-mmm-yyyy",
                                dateConfig: {
                                    maxDate: new Date(),

                                },
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
                            },
                        },
                    ],
                },
            ],


        },
    ],
};
